module.exports = __webpack_public_path__ + "static/media/Data_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.6b1391a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dataAnalytics/Data_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png
// module id = 56
// module chunks = 0